import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
// import Container from "../../components/container";
import { ReactComponent as TickCircle } from "../../Assets/icons/tick-circle.svg";
import { ReactComponent as Tick } from "../../Assets/icons/tick.svg";
import { ReactComponent as ArrowLeft } from "../../Assets/icons/arrow-left.svg";

import "./style.scss";
const Success = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div props={{ "data-show": "orders" }} title={"جزئیات سفارش"}>
      <div className="payment-page">
        <div className="payment-box-success">
          <TickCircle />
          <p className="toast-message">پرداخت شما با موفقیت ثبت شد</p>
          <p className="cartino-message">
            اشتراک ویژه شما به مدت ۳۶۵ روز شارژ گردید
          </p>
          <div className="tracking-code">
            <p>کد پیگیری پرداخت: </p>
            <p>{id}</p>
          </div>
          <div className="button-wrapper">
            <button
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              <p>داشبورد</p>
              <span className="icon-left-wrapper">
                <ArrowLeft />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
